module.exports = __webpack_public_path__ + "img/architecture-1-600x450.cc51ac17.jpg";